import ActionUtility from "../ActionUtility";

export default class CampaignAction {
  static GET_CAMPAIGNS = "CampaignAction.GET_CAMPAIGNS";
  static CREATE_CAMPAIGN = "CampaignAction.CREATE_CAMPAIGN";
  static UPDATE_CAMPAIGN = "CampaignAction.UPDATE_CAMPAIGN";
  static DELETE_CAMPAIGN = "CampaignAction.DELETE_CAMPAIGN";

  static GET_CAMPAIGN = "CampaignAction.GET_CAMPAIGN";
  static GET_CAMPAIGN_AVATARS = "CampaignAction.GET_CAMPAIGN_AVATARS";
  static GET_CAMPAIGN_STATS = "CampaignAction.GET_CAMPAIGN_STATS";

  static CREATE_CAMPAIGN_EVENT = "CampaignAction.CREATE_CAMPAIGN_EVENT";
  static CREATE_CAMPAIGN_EVENTS = "CampaignAction.CREATE_CAMPAIGN_EVENTS";
  static UPDATE_CAMPAIGN_EVENT = "CampaignAction.UPDATE_CAMPAIGN_EVENT";
  static DELETE_CAMPAIGN_EVENT = "CampaignAction.DELETE_CAMPAIGN_EVENT";
  static GET_CAMPAIGN_POST = "CampaignAction.CREATE_CAMPAIGN_POST";

  static GET_AI_EVENT_CONTENT = "CampaignAction.GET_AI_EVENT_CONTENT";


  static GET_CAMPAIGN_EVENTS = "CampaignAction.GET_CAMPAIGN_EVENTS";
  static GET_MORE_CAMPAIGN_EVENTS = "CampaignAction.GET_MORE_CAMPAIGN_EVENTS";
  static GET_CAMPAIGN_DAILY_EVENTS = "CampaignAction.GET_CAMPAIGN_DAILY_EVENTS";


  static UPDATE_CAMPAIGN_STATE = "CampaignAction.UPDATE_CAMPAIGN_STATE";
  static UPDATE_CAMPAIGN_FILTERS = "CampaignAction.UPDATE_CAMPAIGN_FILTERS";

  static getCampaigns(filters = {}, callback) {
    return ActionUtility.createAction(CampaignAction.GET_CAMPAIGNS, {
      filters,
      callback,
    });
  }

  static createCampaign(data, callback) {
    return ActionUtility.createAction(CampaignAction.CREATE_CAMPAIGN, {
      data,
      callback,
    });
  }

  static updateCampaign(id, data, callback) {
    return ActionUtility.createAction(CampaignAction.UPDATE_CAMPAIGN, {
      data,
      callback,
      id
    });
  }

  static deleteCampaign(id, callback) {
    return ActionUtility.createAction(CampaignAction.DELETE_CAMPAIGN, {
      id,
      callback,
    });
  }


  static updateCampaignState(action) {
    return ActionUtility.createAction(CampaignAction.UPDATE_CAMPAIGN_STATE, action);
  }

  static updateCampaignFilters(action) {
    return ActionUtility.createAction(CampaignAction.UPDATE_CAMPAIGN_FILTERS, action);
  }



  static getCampaign(id, callback) {
    return ActionUtility.createAction(CampaignAction.GET_CAMPAIGN, { id, callback });
  }

  static getCampaignStats(id, callback) {
    return ActionUtility.createAction(CampaignAction.GET_CAMPAIGN_STATS, { id, callback });
  }

  static getCampaignAvatars(id, callback) {
    return ActionUtility.createAction(CampaignAction.GET_CAMPAIGN_AVATARS, { id, callback });
  }

  static createCampaignEvent(stepId, eventsData, callback) {
    return ActionUtility.createAction(CampaignAction.CREATE_CAMPAIGN_EVENT, { stepId, eventsData, callback });
  }

  static createCampaignEvents(stepId, eventsArray, callback) {
    return ActionUtility.createAction(CampaignAction.CREATE_CAMPAIGN_EVENTS, { stepId, eventsArray, callback });
  }

  static updateCampaignEvent(eventId, eventData, callback) {
    return ActionUtility.createAction(CampaignAction.UPDATE_CAMPAIGN_EVENT, { eventId, eventData, callback });
  }

  static deleteCampaignEvent(event, callback) {
    return ActionUtility.createAction(CampaignAction.DELETE_CAMPAIGN_EVENT, { event, callback });
  }

  static getCampaignPost(postId, callback) {
    return ActionUtility.createAction(CampaignAction.GET_CAMPAIGN_POST, { postId, callback });
  }

  static getAIEventContent(stepId, generationRequest = {}, callback) {
    return ActionUtility.createAction(CampaignAction.GET_AI_EVENT_CONTENT, { stepId, generationRequest, callback });
  }

  static getCampaignEvents(stepId, filters, callback) {
    return ActionUtility.createAction(CampaignAction.GET_CAMPAIGN_EVENTS, { stepId, filters, callback });
  }

  static getMoreCampaignEvents(stepId, filters, callback) {
    return ActionUtility.createAction(CampaignAction.GET_MORE_CAMPAIGN_EVENTS, { stepId, filters, callback });
  }

  static getCampaignDailyEvents(stepId, filters, callback) {
    return ActionUtility.createAction(CampaignAction.GET_CAMPAIGN_DAILY_EVENTS, { stepId, filters, callback });
  }

}
